import React, {useEffect, useState} from 'react'
import LoadingScreen from "react-loading-screen";
import logo from "../../assets/img/logo/logo_aig_login-2.png";
import Page from "../../components/Page";
import './stylesEstadoSuscripcion.scss'
import {Button} from 'reactstrap'
import queryString from 'query-string'
import {Link, withRouter} from "react-router-dom";
import {useSolicitarSuscripcionRenovacion} from "./ComprasHooks";
import {Alert} from 'reactstrap';

const estados = {
  R: 'RECHAZADO',
  A: 'APROBADO',
  P: 'PENDIENTE'
}

const EstadoSuscripcionContainer = ({location}) => {

  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const solicitarSuscripcion = useSolicitarSuscripcionRenovacion();

  const [visible, setVisible] = useState(false);

  const onDismiss = () => setVisible(false);

  useEffect(() => {

    const {query} = queryString.parse(location.search)
    //const b64 = Buffer.from(JSON.stringify(data)).toString("base64")
    const decoded = new Buffer(query, 'base64').toString('ascii')
    setData(JSON.parse(decoded))
    console.log(JSON.parse(decoded))
  }, []);

  if (!data) return null;


  const onClickIntentarNuevamente = async () => {
    setLoading(true)
    const res = await solicitarSuscripcion(data.idPoliza)

    if (res.transaccion && res.traUrl) {
      window.location.href = res.traUrl
    } else {
      setVisible(true)
      setLoading(false)
    }
  }


  return (<main className="bg-light">

    <div className="cr-content container-fluid">

      <div className="container-body-spaces">

        <LoadingScreen
          loading={isLoading}
          bgColor="#f1f1f1"
          spinnerColor="#001871"
          textColor="#676767"
          logoSrc={logo}
          text={"Cargando..."}
        >
          <Page title="Estado de Suscripción"
                breadcrumbs={[{name: "Estado de Suscripción", active: true}]}>

            <div className="row">
              <div className="col-md-12">
                <Alert
                  className="text-uppercase" color="warning" isOpen={visible}
                  toggle={onDismiss}
                >
                  HA OCURRIDO UN PROBLEMA AL HACER LA PETICIóN DE SUSCRIPCóN
                </Alert>
              </div>

              <div className="col-12 text-center my-5">
                <h4>Su suscripción se encuentra en estado: {data.estado}</h4>
              </div>
              <div className="col-12 text-center">
                <div className="ctn">
                  <div className="circulo">
                    <div className="ctn-interior">
                      <div className="check">
                        <strong className="text-white" style={{fontSize: '20px'}}>
                          ✓
                        </strong>
                      </div>

                      <div className="center-text">
                        <h6 className="font-weight-bold mt-3"
                            style={{fontSize: '15px'}}>Cobro Prueba</h6>
                        <h6 className="font-weight-bold" style={{fontSize: '15px'}}>
                          ${1}
                        </h6>
                        <h6
                          style={{fontSize: '13px', color: '#0e428a'}}>
                          El cobro realizado sera reversado de forma automática
                        </h6>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 text-center mt-5">

                <h5>Producto: {data.producto}</h5>
                <h5>Número de Venta: {data.numeroPoliza}</h5>
                <h5>Referencia PlacetoPay: {data.referencia}</h5>
                <h5>Referencia Interna: {data.referenciaInterna}</h5>

                {
                  data.estado === estados.R &&
                  <Button
                    className="btn-primary mt-5 p-2"
                    onClick={onClickIntentarNuevamente}
                  >
                    Intentar nuevamente
                  </Button>
                }


                {
                  data.estado === estados.A &&
                  <Button
                    tag={Link}
                    to="/mis-compras"
                    className="btn-primary mt-5 p-2"
                  >
                    Volver a mis compras
                  </Button>
                }

              </div>

            </div>


          </Page>

        </LoadingScreen>


      </div>

    </div>

  </main>)

}

export default withRouter(EstadoSuscripcionContainer)